import { ResourcesRequest } from '../ResourcesRequest'
import ResourcesStore from '../ResourcesStore'
import { observable } from 'mobx'

class ShareDocumentStore {
  @observable isLoading = false
  @observable parentFolderId = null
  @observable folders = []
  @observable breadCrumb = []

  share = async data => {
    this.isLoading = true
    await ResourcesRequest.share(data)
    ResourcesStore.search()
    this.isLoading = false
  }

  clearStore = () => {
    this.isLoading = false
    this.folders = []
    this.breadCrumbs = []
    this.parentFolderId = null
  }
}

export default new ShareDocumentStore()
